import { toast } from "react-toastify"
import mainAxios from "../../../services/mainAxios"
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../AppContext";



export const useGetPayrollById= (id)=>{
  const [loading,setLoading] = useState(true)
  const [payroll,setPayroll] = useState()

  const getPayroll =async (payrollId)=>{
    setLoading(true)
    return mainAxios.post("/salary-orders/search",{
      object: "GetSalaryOrder",
      params: { id:payrollId ?? id }
    }).then(res=>{
      setLoading(false)
      if(res.data.status){
        setPayroll(res.data.content[0])
        return res.data.content[0]
      }
      return null
    })
    .catch(err=>{
      setLoading(false)
      return null
    })
  }

  useEffect(()=>{
    if(id){
      getPayroll()
    }
  },[id])

  return {getPayroll,loading,setLoading,payroll,setPayroll}
}


export const useSavePayroll= ({valid}={})=>{
  const [loading,setLoading] = useState(false)
  const history = useHistory()
  const { t } = useTranslation("translations");
  const {selectedCompany:[selectedCompany],user:[user]}= useAppContext()

  const savePayrollFn = ({payroll,actionStatus={},onSuccess,onError,showSuccessToast=true}={})=>{
    const { action="SAVE"  } = actionStatus

    setLoading(true)
    if(valid && !valid()){
      toast.error(t("common.fixValidations"),{ containerId: "all_toast" })
      setLoading(false);
      return  
    }
    const parsedBody={
      operation:action.toUpperCase(),
      content:{
        ...payroll,
        companyId:selectedCompany,
        salaryRecords:payroll.salaryRecords.map((record,rowNumber)=>({...record,rowNumber:rowNumber+1}))
      },
      nuis: user?.companiesRights.find(
          (company) => company.id === parseInt(selectedCompany)
      )?.nuis,
    }
    mainAxios
      .post("/salary-orders/save",parsedBody,{ showSuccessToast })
      .then((res) => {
        setLoading(false);
        if(res.data.status){
          if(onSuccess){
            onSuccess(res.data.content[0])
          }else{
            history.push("/edit-payroll/" + res.data.content[0].id);
          }
          return res.data.content[0]
        }
        if(onError)onError(res)

      })
      .catch((err) => {
        if(onError)onError(err)
        setLoading(false);
      });
  }
  return {savePayrollFn,loading,setLoading}
}

export const useDuplicatePayroll = ({ currentPayroll, id, onSuccess } = {}) => {
  const { getPayroll } = useGetPayrollById();
  const { t } = useTranslation("translations");
  const [duplicateLoading, setDuplicateLoading] = useState(false);

  const history = useHistory()
  const { savePayrollFn } = useSavePayroll({
    valid: () => true
  });

  const duplicatePayroll =async (currentId) => {
    setDuplicateLoading(true);

    let payrollToUse = currentPayroll 

    if(!currentPayroll){
      payrollToUse = await getPayroll(currentId ?? id)
    }
    
    


    if (!payrollToUse) {
      console.error("No payroll data available");
      toast.error(t("payroll.noDataAvailable") || "No payroll data available", {
        containerId: "all_toast"
      });
      return;
    }

    const {
      recordDate,
      recordUser,
      modificationDate,
      modificationUser,
      id: payrollId,
      requestId,
      createdDateTime,
      transactionId,
      transactionDate,
      approvalUser,
      approvalDate,
      sentToBankDate,
      parentSalaryOrderId,
      salaryOrderHistorics,
      conditions,
      comment,
      ...restPayroll
    } = payrollToUse;

    const currentDate = Date.now();

    const cleanedSalaryRecords = restPayroll.salaryRecords?.map((record) => {
      const {
        id,
        recordDate,
        recordUser,
        modificationDate,
        modificationUser,
        bankReferenceNumber,
        bankStatus,
        bankPaymentDate,
        rowNumber,
        originalBankStatus,
        bankStatusName,
        bankStatusDisplayName,
        isSuccess,
        isFailed,
        isPending,
        ...restRecord
      } = record;
      return restRecord;
    }) || [];

    const cleanedPayroll = {
      ...restPayroll,
      workflowStatus: {
        id: 1,
        name: "DRAFT"
      },
      requestedExecutionDate: currentDate,
      salaryRecords: cleanedSalaryRecords,
      bankStatus: null,
      bankStatusType: null,
      bankStatusSummary: null,
      errorMessage: null,
      pendingMessage: null,
      action: null,
      isParent: true,
      generationLevel: 0
    };

    if (cleanedPayroll.description) {
      cleanedPayroll.description = cleanedPayroll.description.trim();
    }
    if (cleanedPayroll.companyAccountNumber) {
      cleanedPayroll.companyAccountNumber = cleanedPayroll.companyAccountNumber.trim();
    }



    savePayrollFn({
      payroll: cleanedPayroll,
      actionStatus: { action: "SAVE" },
      onSuccess: (savedPayroll) => {
        setDuplicateLoading(false);
        toast.success(t("payRoll.isPayrollDuplicated"), {
          containerId: "all_toast"
        });
        history.push("/edit-payroll/" + savedPayroll.id);

        if (onSuccess) {
          onSuccess(savedPayroll);
        }
      },
      showSuccessToast: false
    });
    setDuplicateLoading(false)
  };

  return { 
    duplicatePayroll, 
    loading:  duplicateLoading 
  };
};
